import Tooltip from '@/components/tooltip';
import closeIcon from '@images/close.svg';
import defaultErrorIcon from '@images/warning.svg';
import { cn } from '@lib/utils';
import Image, { StaticImageData } from 'next/image';

interface AlertBarProps {
  title: string;
  message: string;
  className?: string;
  isVisible: boolean;
  onClose: () => void;
  icon?: StaticImageData;
}

function AlertBar({
  title,
  message,
  className,
  isVisible,
  onClose,
  icon,
}: AlertBarProps) {
  if (!isVisible) return null;

  return (
    <div
      className={cn(
        'flex w-full items-center rounded-md bg-3b-error-light px-4 py-3',
        className,
      )}
    >
      <div className="mr-3 flex shrink-0 items-center">
        <Image
          src={icon || defaultErrorIcon}
          alt="error"
          width={22}
          height={22}
        />
      </div>

      <div className="mr-3 flex shrink-0 items-center">
        <span className="text-sm font-semibold leading-[22px] tracking-[-0.128px] text-3b-text-primary">
          {title}
        </span>
      </div>

      <div className="flex min-w-0 flex-1 items-center">
        <Tooltip
          content={message}
          className="w-auto max-w-full"
          contentClassName="max-w-[300px]"
        >
          <div className="w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-normal leading-[22px] tracking-[-0.128px] text-3b-text-secondary">
            {message}
          </div>
        </Tooltip>
      </div>

      <div className="ml-3 flex shrink-0 items-center">
        <Image
          src={closeIcon}
          alt="close"
          width={22}
          height={22}
          className="cursor-pointer hover:rounded hover:bg-3b-other-neutral-lightAlpha-100"
          onClick={onClose}
        />
      </div>
    </div>
  );
}

export default AlertBar;
